import { Alert, Divider, Flex, Skeleton } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { ReactComponent as RubIcon } from "images/coins/rubLargeIconRound.svg";
import { ReactComponent as MoneyIcon } from "images/other/money.svg";
import { ReactComponent as ClockIcon } from "images/other/clock.svg";
import { ReactComponent as LockIcon } from "images/other/lock.svg";
import { BalanceItem, BalanceItemMain } from "./BalanceItem";
import { NominalAccount } from "interfaces/nominalAccounts";
import { DataStoreConstructor } from "stores/core/DataStoreConstructor";

interface IBalancesItemsProps {
  store: DataStoreConstructor<NominalAccount>;
}

export const BalancesItems = observer((props: IBalancesItemsProps) => {
  const { data, statuses, polling, stopPolling } = props.store;

  useEffect(() => {
    polling();

    return () => stopPolling();
  }, []);

  if (statuses.loading) {
    return <Skeleton active />;
  }

  if (statuses.fetchError) {
    return <Alert message="Ошибка при загрузке данных" type="error" />;
  }

  return (
    <Flex vertical gap="12px">
      <BalanceItemMain label="Общий баланс средств" value={data.totalBalance} icon={RubIcon} />

      <Divider className="margin-top-none margin-bottom-none" />

      <BalanceItem label="Доступно на номинальном счёте" value={data.availableBalance} icon={MoneyIcon} />
      <BalanceItem label="Заблокировано на заявках" value={data.blockedOnRequests} icon={LockIcon} />
      <BalanceItem label="Заблокировано на вывод" value={data.blockedForWithdrawal} icon={ClockIcon} />
    </Flex>
  );
});
